

import { useSelector, useDispatch } from "react-redux";
import { setup_user_todocs } from "../../slice/mainslice";
import {Grid, Tooltip, Checkbox, createStyles, Indicator, Avatar} from '@mantine/core';
import React from "react";
import intl from "react-intl-universal";


const useStyles = createStyles(() => ({
    margright: {
        marginRight: 10,
      },
    pafleft10:{
        paddingLeft: 3,
        cursor: `pointer`,
    },
}));

const SetupUserToDocsHeader = ({ docsinmeeting, checkboxesOnly }: { docsinmeeting?: any[], checkboxesOnly?: boolean }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const initparticipants = useSelector((state: any) => state.user.meetinguser)
    const iniusersigndocs = useSelector((state: any) => state.user.userhavetosigndocs) || [];

    const activeResourceIds = (docsinmeeting ?? [])
        .filter((doc: any) => doc.isToBeSigned)
        .map((doc: any) => doc.resourceId);

    const data = initparticipants.filter((obj: { role: any; }) => {
        return obj.role !== "gast"
    });

    const handleSelectAllUser = (userId: string, value: boolean) => {
        activeResourceIds.forEach((resourceId: string) => {
            const existing = iniusersigndocs.find((d: any) => d.resourceId === resourceId);
            const currentUsers: string[] = existing ? [...existing.user] : [];
            let newUsers: string[];
            if (value) {
                newUsers = currentUsers.includes(userId) ? currentUsers : [...currentUsers, userId];
            } else {
                newUsers = currentUsers.filter((id: string) => id !== userId);
            }
            dispatch(setup_user_todocs({ resourceId, user: newUsers }));
        });
    };

    const rows = (data || []).map((item: any, index: any) => {

        if (checkboxesOnly) {
            const allChecked = activeResourceIds.length > 0 && activeResourceIds.every((resourceId: string) => {
                const existing = iniusersigndocs.find((d: any) => d.resourceId === resourceId);
                return existing?.user?.includes(item.userId);
            });

            return (
                <React.Fragment key={item.id || index}>
                    <Grid.Col span={1} className={classes.margright}>
                        <Tooltip label={intl.get('SETUP_SELECTALL')} multiline={true}><span>
                        <Checkbox
                            size="md"
                            className={classes.pafleft10}
                            checked={allChecked}
                            disabled={activeResourceIds.length === 0}
                            onChange={(event) => handleSelectAllUser(item.userId, event.currentTarget.checked)}
                            styles={{ input: { cursor: 'pointer', borderColor: allChecked ? 'red' : 'green', borderWidth: 2 } }}
                        />
                        </span></Tooltip>
                    </Grid.Col>
                </React.Fragment>
            );
        }

        let identcolor = "gray"

        if (item.role === "notar"){
            identcolor = "blue"
        }

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

        let inmeetingcolor = "red"
        if (item.meetingParticipantStatus === null) {
          inmeetingcolor = "red"
        }
        if (item.meetingParticipantStatus === "LeftMeeting") {
          inmeetingcolor = "red"
        }
        if (item.meetingParticipantStatus === "InMeeting") {
          inmeetingcolor = "green"
        }

        return (
            <React.Fragment key={item.id || index}>
                <Grid.Col span={1} className={classes.margright}>
                    <Tooltip label={fullname} multiline={true}>
                    <Indicator inline size={8} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
                        <Avatar color={identcolor}  alt={fullname} variant="filled" radius="xl" size="sm">{initialen} </Avatar>
                    </Indicator>
                    </Tooltip>
                </Grid.Col>
            </React.Fragment>
        );
    });

    return (
        <>
            <Grid>
            {rows}
            </Grid>

        </>
    );
}

export default SetupUserToDocsHeader;
